import { useTranslation } from 'react-i18next'

import { Skeleton } from '@/shared/ui/skeleton'

/**
 * Placeholder do AppShell enquanto a sessão carrega. Reproduz as dimensões do
 * shell real (sidebar `w-62`, brand `h-16`, header `h-14`) para não haver salto
 * de layout quando o conteúdo chega.
 */
export function AppShellSkeleton() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-svh" role="status" aria-busy="true" data-testid="app-shell-skeleton">
      <span className="sr-only">{t('app.loading')}</span>

      <aside className="sticky top-0 hidden h-svh w-62 shrink-0 flex-col bg-sidebar md:flex">
        <div className="flex h-16 shrink-0 items-center justify-center gap-3 border-b border-sidebar-border object-center px-5">
          <Skeleton className="size-8 shrink-0 bg-sidebar-accent" />
          <Skeleton className="h-5 w-28 bg-sidebar-accent" />
        </div>
        <div className="space-y-2 p-3">
          {Array.from({ length: 8 }, (_, index) => (
            <Skeleton key={index} className="h-9 w-full bg-sidebar-accent" />
          ))}
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b bg-card px-4 md:px-7">
          <Skeleton className="h-9 w-48 md:w-72" />
          <div className="ml-auto flex items-center gap-2">
            <Skeleton className="size-9" />
            <Skeleton className="size-9 rounded-full" />
          </div>
        </header>

        <main className="mx-auto w-full max-w-7xl flex-1 space-y-6 p-4 md:p-7">
          <Skeleton className="h-9 w-64" />
          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
            {Array.from({ length: 4 }, (_, index) => (
              <Skeleton key={index} className="h-28" />
            ))}
          </div>
          <Skeleton className="h-64 w-full" />
        </main>
      </div>
    </div>
  )
}
